var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10.667C8.87613 10.667 10.667 8.87613 10.667 6.66699C10.667 4.45785 8.87613 2.66699 6.66699 2.66699C4.45785 2.66699 2.66699 4.45785 2.66699 6.66699C2.66699 8.87613 4.45785 10.667 6.66699 10.667Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 20C27.5421 20 29.333 18.2091 29.333 16C29.333 13.7909 27.5421 12 25.333 12C23.1239 12 21.333 13.7909 21.333 16C21.333 18.2091 23.1239 20 25.333 20Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 29.333C8.87613 29.333 10.667 27.5421 10.667 25.333C10.667 23.1239 8.87613 21.333 6.66699 21.333C4.45785 21.333 2.66699 23.1239 2.66699 25.333C2.66699 27.5421 4.45785 29.333 6.66699 29.333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 16.0003H12.0003C9.06699 16.0003 6.66699 14.667 6.66699 10.667V21.3337",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.f1bab112b73b95f0289686a23026d70a.svg";
export { ForwardRef as ReactComponent };